<div class="container" *ngIf="page">
  <p [innerHTML]="page.body | safeHtml"></p>
</div>